/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * Header.tsx
 */

import React from "react";
import ReactDOM from "react-dom";
import HiloReactComponent from "../layout/HiloReactComponent";
import Translation from "../../translation/Translation";
import MenuDropdown from "./MenuDropdown";
import {DEFAULT_MODAL_CONTAINER_ID} from "../layout/Modal";
import PageSelectorModal from "../layout/PageSelectorModal";
import NavigationService, {NavigationListener} from "../../service/NavigationService";
import {Page} from "../../model/pagination/Page";
import {BaseUser} from "../../model/BaseUser";

interface Props {
    user?: BaseUser
}

interface State {
    currentPage?: Page;
}

export default class Header extends HiloReactComponent<Props, State> implements NavigationListener {
    private readonly _navigationService : NavigationService;
    private _modalContainer?: Element;

    constructor(props: Props, state: State) {
        super(props, state);

        this._navigationService = this._serviceRepository.resolve(NavigationService.id) as NavigationService;

        this.state = {
            currentPage: this._navigationService.currentPage
        }
    }

    /**
     * componentDidMount
     */
    public componentDidMount() {
        super.componentDidMount();

        this._modalContainer = document.querySelector(DEFAULT_MODAL_CONTAINER_ID) || undefined;

        this._navigationService.addListener(this);
    };

    /**
     * componentWillUnmount
     */
    public componentWillUnmount() {
        super.componentWillUnmount();

        this._navigationService.removeListener(this);
    };

    /**
     * _flagButton
     * @returns {any}
     * @private
     */
    private _flagButton = (props: { t: Translation }) => {
        return <button className="button is-small" onClick={this._translationService.toggleLanguage}>
                            <span className="icon">
                                <p>{props.t.languageFlag}</p>
                            </span>
        </button>
    };

    /**
     * _loadBaseRoute
     * @private
     */
    private _loadBaseRoute = () => {
        this._navigationService.load("/")
    };

    private _showUserPreferenceModal = () => {
        if (!this._modalContainer || !this.props.user) {
            console.error("Cannot _showUserPreferenceModal");
            return;
        }

        const modal = <MenuDropdown title={t => t.userMenu}/>;

        ReactDOM.render(modal, this._modalContainer);
    };

    /**
     * render
     */
    public render(): JSX.Element {
        const {currentPage} = this.state;
        const {user} = this.props;

        return <nav className="header" role="navigation" aria-label="dropdown navigation">
            <div className={"container"}>
                <h1>OAuth Hilo</h1>
                {currentPage && <div className={"page-selector-header"} onClick={this._showPageSelector}>
                    {currentPage?.titleAccessor(this.t)}
                    <img className={"header-user-info-arrow"} src={"/img/expand_arrow_primary.png"}
                         alt={"expand_arrow"}/>
                </div>}
                <div className={"user-infos"} onClick={this._showUserPreferenceModal}>
                    <div className={"user-identity"}>
                        <p>{user ? `${user.firstname} ${user.lastname}` : this.t.loading}</p>
                        <p className={"group"}>{user?.email}</p>
                    </div>
                    <img className={"header-user-info-arrow"} src={"/img/expand_arrow_primary.png"}
                         alt={"expand_arrow"}/>
                </div>
            </div>
        </nav>
    }

    /**
     * _showPageSelector
     * @private
     */
    private _showPageSelector = () => {
        if (!this._modalContainer || !this.props.user) {
            console.error("Cannot _showPageSelector");
            return;
        }

        const modal = <PageSelectorModal title={t => t.pages}/>;

        ReactDOM.render(modal, this._modalContainer);
    }

    /**
     * historyHasBeenUpdated
     */
    historyHasBeenUpdated(): void {
        this.setState({
            currentPage: this._navigationService.currentPage
        })
    }
}